import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f89a686"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "select_time" }
const _hoisted_3 = { class: "date_select" }
const _hoisted_4 = { class: "time_select" }
const _hoisted_5 = { class: "select_box" }
const _hoisted_6 = { class: "select_weather_box" }

import DialogBase from '@/components/molecules/DialogBase'
import DatePicker from '@/components/atoms/DatePicker'
import TimeSelector from '@/components/atoms/TimeSelector'
import SimpleSelectBox from '@/components/atoms/SimpleSelectBox'
import APP from '@/js/const/app'
import i18n from '@/plugins/i18n'
import { zeroPadding } from '@/js/utils/filters'
import { computed, ref, withDefaults } from 'vue'
import { ElMessage } from 'element-plus'

type PropsType = {
  modelValue?: boolean
}

type SubtypesType = {
  value: string
  label: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectWeatherDialog',
  props: {
    modelValue: { type: Boolean, default: false }
  },
  emits: ["changed", "close", "update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'changed', date: Date, time: string, weather: string | null, weatherTypeNumber: number): void
  (e: 'close'): void
  (e: 'update:modelValue', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: boolean };





const selectWeatherShow = ref<boolean>(false)
const selectWeatherValue = ref<string | null>(null)
const weatherTypeNumber = ref<number>(0)
const weatherTypeOptions = APP.WEATHER_TYPE
const weatherType = ref<SubtypesType[] | null>(null)
const selectedDate = ref<Date>(new Date())
const selectedTime = ref<string>(zeroPadding(new Date().getHours(), 2) + ':00')
const beforeData = ref<[Date, string, number]>([
  new Date(),
  zeroPadding(new Date().getHours(), 2) + ':00',
  1,
])

const selectType = () => {
  // find subtypes for selected type
  const weatherTypeOption = weatherTypeOptions.find(
    (it: { value: number; label: string; subtypes: null | SubtypesType }) =>
      it.value === weatherTypeNumber.value
  )
  if (weatherTypeOption.subtypes) {
    // show subtypes
    const subtypes = weatherTypeOption.subtypes
    selectWeatherShow.value = true
    weatherType.value = subtypes
    selectWeatherValue.value = subtypes[0].value
  } else {
    // no subtypes
    selectWeatherShow.value = false
    weatherType.value = null
    selectWeatherValue.value = null
  }
}

const selectWeatherType = (type: string | null) => {
  selectWeatherValue.value = type
}

const selectWeatherLayer = () => {
  if (!selectedDate.value || !selectedTime.value) {
    ElMessage({
      message: i18n.global.t('select_weather_dialog.please_select'),
      type: 'error',
    })
    return
  }
  emit(
    'changed',
    selectedDate.value,
    selectedTime.value.substring(0, 2),
    selectWeatherValue.value,
    weatherTypeNumber.value
  )
  internalValue.value = false
  beforeData.value = [selectedDate.value, selectedTime.value, weatherTypeNumber.value]
}

const returnSelect = () => {
  selectedDate.value = beforeData.value[0]
  selectedTime.value = beforeData.value[1]
  weatherTypeNumber.value = beforeData.value[2]
  selectType()
  emit('close')
}

const internalValue = computed({
  get: () => props.modelValue,
  set: (newVal) => {
    if (props.modelValue !== newVal) {
      emit('update:modelValue', newVal)
    }
  },
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DialogBase), {
    modelValue: _unref(internalValue),
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(internalValue) ? (internalValue).value = $event : null)),
    onApprove: selectWeatherLayer,
    onClose: returnSelect
  }, {
    title: _withCtx(() => [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t('select_weather_dialog.weather_information')), 1)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_unref(DatePicker), {
              modelValue: selectedDate.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDate).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("span", _hoisted_4, [
            _createVNode(_unref(TimeSelector), {
              modelValue: selectedTime.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedTime).value = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(SimpleSelectBox), {
            modelValue: weatherTypeNumber.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((weatherTypeNumber).value = $event)),
            size: "large",
            options: _unref(weatherTypeOptions),
            onChange: selectType
          }, null, 8, ["modelValue", "options"]),
          _withDirectives(_createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(SimpleSelectBox), {
              modelValue: selectWeatherValue.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectWeatherValue).value = $event)),
              size: "large",
              options: weatherType.value,
              onChange: selectWeatherType
            }, null, 8, ["modelValue", "options"])
          ], 512), [
            [_vShow, selectWeatherShow.value]
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})